import * as Sentry from '@sentry/react';

import React from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';

Sentry.init({
  dsn: 'https://52f496d5cf8274b2f28aae3f30f58003@o439050.ingest.us.sentry.io/4508995067183105',
  release: window.SENTRY_RELEASE,
  environment: window.ENV,
  ignoreErrors: [
    'token is expired',
    'invalid token length',
    'Failed to fetch property groups',
    'Failed to fetch',
    'Load failed',
    'permission denied',
    'NetworkError when attempting to fetch resource',
  ],
  beforeSend(event, hint) {
    const error = hint?.originalException;

    // Drop unhandled rejections with undefined/empty values
    if (
      event.exception?.values?.some(
        (v) =>
          v.type === 'UnhandledRejection' &&
          (!v.value || v.value === 'undefined'),
      )
    ) {
      return null;
    }

    // Drop TypeError: Failed to fetch / Load failed
    if (
      error instanceof TypeError &&
      (error.message === 'Failed to fetch' || error.message === 'Load failed')
    ) {
      return null;
    }

    // Drop 401 permission denied errors
    const message = error?.message || event.message || '';
    if (/401/.test(message) && /permission denied/i.test(message)) {
      return null;
    }

    return event;
  },
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation: useLocation,
      useNavigationType: useNavigationType,
      createRoutesFromChildren: createRoutesFromChildren,
      matchRoutes: matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    window.USER_BASE_URL,
    window.PROPERTY_BASE_URL,
    window.JOB_BASE_URL,
    window.PERMIT_BASE_URL,
    window.REVISION_BASE_URL,
    window.FILE_BASE_URL,
    window.VEHICLE_BASE_URL,
    window.QR_CODE_BASE_URL,
    window.PAYMENT_BASE_URL,
  ],
  replaysOnErrorSampleRate: 1.0,
});
